<!-- 备注/标记唛码弹窗 -->
<template> 
    <div>
        <el-dialog v-dialogDrag :title="title" :visible.sync="textareaShow" width="60%" :before-close="handleClose" :close-on-click-modal="false">
           <el-input type="textarea" :rows="10" v-model="textareaValue"> </el-input>
           <div>
            ({{valueLength}}字节)
           </div>

        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        title:{
            type: String,
            default: ''
        },
        textareaShow: {
            type: Boolean,
            default: false
        },
        textareaValue:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            valueLength:0,
        }
    },
    watch: {
        textareaValue: {
            handler(newVal,oldVal) {
                this.valueLength = [...newVal].length;
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        }
    },
    mounted() { 

    },
    methods: { 
        handleClose() {
            this.$emit('textareaClose', false);
        }
    }
}
</script>
<style lang="css" scoped>

</style>